/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDocumentRequest
 */
export interface UpdateDocumentRequest {
    /**
     * 
     */
    expected_revision: number;
    /**
     * 
     */
    request_item_ids?: Set<string>;
    /**
     * 
     */
    display_name?: string;
}

/**
 * Check if a given object implements the UpdateDocumentRequest interface.
 */
export function instanceOfUpdateDocumentRequest(value: object): value is UpdateDocumentRequest {
    if (!('expected_revision' in value) || value['expected_revision'] === undefined) return false;
    return true;
}

export function UpdateDocumentRequestFromJSON(json: any): UpdateDocumentRequest {
    return UpdateDocumentRequestFromJSONTyped(json, false);
}

export function UpdateDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_revision': json['expected_revision'],
        'request_item_ids': json['request_item_ids'] == null ? undefined : new Set(json['request_item_ids']),
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
    };
}

export function UpdateDocumentRequestToJSON(json: any): UpdateDocumentRequest {
    return UpdateDocumentRequestToJSONTyped(json, false);
}

export function UpdateDocumentRequestToJSONTyped(value?: UpdateDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_revision': value['expected_revision'],
        'request_item_ids': value['request_item_ids'] == null ? undefined : Array.from(value['request_item_ids'] as Set<any>),
        'display_name': value['display_name'],
    };
}

